function invertBbox ({ bbox }) {
  const invertedBbox = [bbox[0], bbox[2], bbox[1], bbox[3]]

  return invertedBbox
}

export default invertBbox
